import { render, staticRenderFns } from "./naviTeaser.vue?vue&type=template&id=ce213186&"
import script from "./naviTeaser.vue?vue&type=script&lang=js&"
export * from "./naviTeaser.vue?vue&type=script&lang=js&"
import style0 from "./naviTeaser.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce213186')) {
      api.createRecord('ce213186', component.options)
    } else {
      api.reload('ce213186', component.options)
    }
    module.hot.accept("./naviTeaser.vue?vue&type=template&id=ce213186&", function () {
      api.rerender('ce213186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/naviTeaser/naviTeaser.vue"
export default component.exports